<template>
  <div>
    <wc-page-title :title='title' :subtitle='subtitle'>
       <template v-slot:rightSide>
         <wc-archive-button :isArchived='item.archived' @toggleArchive='toggleArchive'></wc-archive-button>
       </template>
    </wc-page-title>
    <v-container v-if='item.archived'>
      <v-alert border='bottom' type='error'>This item is archived</v-alert>
    </v-container>
    <router-view
      :item='item'
      @update='updateItem'
    ></router-view>
  </div>
</template>

<script>
import assetsAPI from '@/modules/assets/api/vehicles'

export default {
  name: 'vehicles-base',
  data: () => ({
    isLoading: true,
    item: null
  }),
  computed: {
    title () {
      if (this.item) {
        return this.item.name
      }
      return ''
    },
    subtitle () {
      if (this.item) {
        return this.item.license_plate
      }
      return ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.item = await assetsAPI.getVehicle(this.$route.params.id)
      this.isLoading = false
    },
    async updateItem (item) {
      this.item = await assetsAPI.updateVehicle(item)
    },
    toggleArchive () {
      this.item.archived = !this.item.archived
      this.updateItem (this.item)
    }
  }
}
</script>